import React from 'react';
import fuse from '../../../_libs/redux-fusion';
import {requestToButtonState} from '../../../core-utilities/redux-request/utils';
import {getUserId} from '../../../auth/reducers';
import {getChatModalSubscriptionRequest} from '../../reducers/state';
import {actions} from '../../redux/chatChannelModal';
import {ChatListSettingsView} from './ChatListSettingsView';

const StreamedComponent = (state$, dispatch) => (props$) => {
  const onSubscribe = parentId => dispatch(actions.updateSubscription.sendRequest({parentId, subscribe: true}));
  const onUnsubscribe = parentId => dispatch(actions.updateSubscription.sendRequest({parentId, subscribe: false}));

  const updateSubscriptionMode$ = state$
    .map(getChatModalSubscriptionRequest)
    .map(requestToButtonState)
    .distinctUntilChanged();

  const userId$ = state$
    .map(getUserId)
    .distinctUntilChanged()
    .takeUntil(props$.last());

  return props$
    .combineLatest(
      updateSubscriptionMode$,
      userId$,
      (props, updateSubscriptionMode, userId) => ({
        ...props,
        channelId: props.parentId,
        isSubscribed: isSubscribed(props.channel, userId),
        updateSubscriptionMode,
        onChangeSubscription: () => {
          if (props.isSubscribed) {
            onUnsubscribe(props.parentId);
          } else {
            onSubscribe(props.parentId);
          }
        },
      }),
    );
};

export const ChatListSettingsContainer = fuse(StreamedComponent)(ChatListSettingsView);

function isSubscribed(channel, userId) {
  if (!channel || !channel.subscribers) {
    return false;
  } else {
    return channel.subscribers.indexOf(userId) > -1;
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatListSettings/ChatListSettingsContainer.js